const ENDPOINT = 'GETanalyticsData';
var TimePeriods;
(function (TimePeriods) {
    TimePeriods["THIS_WEEK"] = "thisweek";
    TimePeriods["LAST_SEVEN_DAYS"] = "lastsevendays";
    TimePeriods["LAST_THIRTY_DAYS"] = "lastthirtydays";
    TimePeriods["YESTERDAY"] = "yesterday";
    TimePeriods["LAST_MONTH"] = "lastmonth";
    TimePeriods["LAST_SIX_MONTH"] = "lastsixmonths";
    TimePeriods["LAST_YEAR"] = "lastyear";
    TimePeriods["THIS_YEAR"] = "thisyear";
    TimePeriods["CUSTOM"] = "custom";
})(TimePeriods || (TimePeriods = {}));
function getAnalyticsData(gateway, params = null) {
    if (!params)
        return;
    return gateway.get(getAnalyticsData.endpoint, params);
}
getAnalyticsData.endpoint = ENDPOINT;

export { TimePeriods, getAnalyticsData as default };
//# sourceMappingURL=getAnalyticsData.js.map
